import {TransactionKind, TransferType} from '@transactions/graphql';
import {TRANSFER_TYPE_LABELS} from 'src/TransferKindSelect';

/** Menu order of the Type filter's Payments tier. */
export const PAYMENT_KINDS: readonly TransactionKind[] = [
  TransactionKind.Spending,
  TransactionKind.Income,
];

/**
 * Menu order of the Type filter's Transfers tier: the subtypes in assign-form
 * order, then the transfers still missing one.
 */
export const TRANSFER_KINDS: readonly TransactionKind[] = [
  TransactionKind.CreditCardPayment,
  TransactionKind.AccountTransfer,
  TransactionKind.Prepaid,
  TransactionKind.Refund,
  TransactionKind.Reimbursement,
  TransactionKind.Conversion,
  TransactionKind.UntypedTransfer,
];

export const TRANSACTION_KIND_LABELS: Record<TransactionKind, string> = {
  [TransactionKind.Spending]: 'Spending',
  [TransactionKind.Income]: 'Income',
  [TransactionKind.CreditCardPayment]:
    TRANSFER_TYPE_LABELS[TransferType.CreditCardPayment],
  [TransactionKind.AccountTransfer]:
    TRANSFER_TYPE_LABELS[TransferType.AccountTransfer],
  [TransactionKind.Prepaid]: TRANSFER_TYPE_LABELS[TransferType.Prepaid],
  [TransactionKind.Refund]: TRANSFER_TYPE_LABELS[TransferType.Refund],
  [TransactionKind.Reimbursement]:
    TRANSFER_TYPE_LABELS[TransferType.Reimbursement],
  [TransactionKind.Conversion]: TRANSFER_TYPE_LABELS[TransferType.Conversion],
  [TransactionKind.UntypedTransfer]: 'No subtype',
};

export const isTransactionKind = (value: string): value is TransactionKind =>
  Object.keys(TRANSACTION_KIND_LABELS).includes(value);
